import get from 'lodash-es/get'
import querystring from 'query-string'
import { noIndex, setErrorPage, setSeoMeta } from '../actions/common'
import { logError, LandingPageUnpublishedError } from '../utils/errors'
import axiosVerbose from '../utils/axios/axiosVerbose'

const fetchLandingPageContent = (location, apiUrlPrefix) => {
  return (dispatch, getState) => {
    const site = get(getState(), 'common.currentSite') || 'themeforest'
    const queryString = querystring.stringify({
      site,
      path: location.pathname
    })

    return axiosVerbose
      .get(`${apiUrlPrefix}/shopfront_api/landing_page?${queryString}`)
      .then(res => {
        const { title, meta_description, html, css, published } = res.data

        if (!published) {
          throw new LandingPageUnpublishedError()
        }

        dispatch(setSeoMeta({ title, meta_description }))

        return dispatch(fetchLandingPageContentSuccess({ html, css }))
      })
      .catch(err => {
        if (get(err, 'response.status') !== 404) {
          logError(err)
        }

        dispatch(noIndex())
        dispatch(setErrorPage('NotFoundContainer'))

        return dispatch(fetchLandingPageContentFailure(err))
      })
  }
}

const fetchLandingPageContentSuccess = content => {
  return {
    type: 'fetchLandingPageContentSuccess',
    payload: content
  }
}

const fetchLandingPageContentFailure = error => {
  return {
    type: 'fetchLandingPageContentFailure',
    error: true,
    httpStatus: get(error, 'response.status', 404)
  }
}

export default fetchLandingPageContent
